import { locales } from '#shared/locales.js';
export const AVAILABLE_LANGUAGES = ['en', 'fr-FR', 'fr-BE', 'es'];
export const COUNTRY_TO_LANGUAGE = {
    FRA: 'fr-FR',
    ESP: 'es',
    BEL: 'fr-BE'
};
export const LANGUAGE_DEFAULT = 'en';
export const LANGUAGE_RESOURCES = AVAILABLE_LANGUAGES.reduce((acc, lang) => {
    acc[lang] = { translation: locales[lang] ?? locales[LANGUAGE_DEFAULT] };
    return acc;
}, {});
//# sourceMappingURL=lang.model.js.map